import {BaseSectionStatus} from './base-section-status'
import type {MergeBoxSectionStatus} from './types'
import type {StackMergeConditionPayload} from '../../page-data/payloads/merge-box'
import {getStackCondition} from '../json-api-helpers'

export type StackSectionStatusType = 'PASSED' | 'FAILED' | 'BLOCKED' | 'UNKNOWN'

export class StackSectionStatus extends BaseSectionStatus<StackSectionStatusType> {
  #stackCondition: StackMergeConditionPayload | undefined

  override get shouldRender() {
    return !!this.featureFlags['pull_request_stacks'] && this.isStacked
  }

  override get sectionStatus(): StackSectionStatusType {
    const e = this.entry

    switch (this.stackCondition?.result || 'UNKNOWN') {
      case 'FAILED':
        if (e?.failedSubConditions && e.failedSubConditions.length > 0) {
          // This stack entry has failed to meet some condition
          return 'FAILED'
        } else {
          // A previous entry in the stack has failed to meet some condition
          return 'BLOCKED'
        }
      case 'PASSED':
        return 'PASSED'
      case 'UNKNOWN':
        return 'UNKNOWN'
    }
  }

  override get mergeBoxStatus(): MergeBoxSectionStatus {
    return this.stackCondition?.result || 'UNKNOWN'
  }

  get isStacked() {
    return !!this.stackCondition?.isStacked
  }

  get entry() {
    return this.entries?.find(e => e.position === 'CURRENT')
  }

  get entries() {
    return this.stackCondition?.entries
  }

  get stackCondition() {
    if (!this.#stackCondition) {
      this.#stackCondition = getStackCondition(this.mergeRequirements)
    }
    return this.#stackCondition
  }
}
